export default defineEventHandler(async (event) => {
    //any error dont redirect
    if (event.path.includes('/__nuxt_error')) return
    const requeststedUrl = getRequestURL(event)
    //if you are requesting root and are logged in redirect to dashboard
    if (requeststedUrl.pathname == '/' && getCookie(event, 'JSESSIONID')) {
        await sendRedirect(event, '/dashboard')
    }

    //if user is not logged in
    if (!getCookie(event, 'JSESSIONID')) {
        console.log('Access denied. No JSESSIONID')
        //If user is trying to get to anything else than login or requesting the login, redirect them to the loginpage with the url as a param
        if (requeststedUrl.pathname != '/login' && requeststedUrl.pathname != '/api/login') {
            await sendRedirect(event, `/login${requeststedUrl.pathname != '/' ? '?redirect_uri=' + encodeURIComponent(requeststedUrl.pathname+requeststedUrl.search) : ''}`, 401)
        }
    }
})